import * as React from 'react';

function SvgBinDeleteStrike2(props) {
  return (
    <svg
      width="1.4em"
      height="1.4em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.44 6.173v.874h4.514v-.874H12.44zm-1.4-.7v1.574H7.814a.709.709 0 00-.087.005.707.707 0 00-.087-.005H5.267a.7.7 0 000 1.4h1.885l.903 15.92a.7.7 0 00.699.66h11.9a.7.7 0 00.698-.661l.89-15.92h1.885a.7.7 0 100-1.4h-2.353a.707.707 0 00-.097.007.705.705 0 00-.097-.006h-3.226V5.473a.7.7 0 00-.7-.7H11.74a.7.7 0 00-.7.7zM8.554 8.447H20.84l-.848 15.18H9.415l-.86-15.18zm2.33 1.144a.65.65 0 00-.613.686l.667 11.653a.65.65 0 101.298-.074l-.667-11.653a.65.65 0 00-.686-.612zm6.914.612a.65.65 0 111.298.074l-.66 11.653a.65.65 0 01-1.298-.073l.66-11.654zm-3.104-.613a.65.65 0 00-.65.65v11.653a.65.65 0 101.3 0V10.24a.65.65 0 00-.65-.65z"
        fill={props.fill ? props.fill : '#414B56'}
      />
    </svg>
  );
}

export default SvgBinDeleteStrike2;
